import { cubicBezier } from './cubic-bezier.mjs';
var easeIn = /*@__PURE__*/cubicBezier(0.42, 0, 1, 1);
var easeOut = /*@__PURE__*/cubicBezier(0, 0, 0.58, 1);
var easeInOut = /*@__PURE__*/cubicBezier(0.42, 0, 0.58, 1);
export { easeIn, easeInOut, easeOut };